import update from 'immutability-helper'
import * as TYPES from '../constants/index'

import {
  addModule,
  addChildModule,
  deleteChildModule,
  deleteModule,
  setModule,
  updateComponentSort,
} from './modules'

import { updateImageBox, updateImageRes, setImgConfig } from './components/imageBox'
import {
  updateTabConfig,
  updateActiveIndex,
  updateTabBase,
  deleteTabChild,
} from './components/tabs'
import { setProductsList } from './components/productList'
import { updateVideoBox } from './components/videoBox'
import { updateTextBox } from './components/textBox'
import { updateMixedBlock } from './components/mixedBlock'
import { updateConference, addConferenceTabs } from './components/conference'
const initState = {
  root: {
    id: 'root',
    render: 'div',
    pid: '',
    config: {
      title: '',
      // availableIn: '',
      imageUrl: '',
      pageId: '',
      shareTit: '',
      shareDes: '',
      shareImg: '',
      bgColor: '#fff',
    },
    childrens: [],
  },
}

// todo 优化
function isContainer(render: string) {
  return render === 'root' || render === 'Tabs' || render === 'AnchorTabs'
}

export default function (state = initState, action) {
  let current = state
  switch (action.type) {
    case TYPES.RESET_TREE:
      return update(state, {
        $set: initState,
      })
    case TYPES.SET_ROOT:
      return update(state, {
        $set: action.root,
      })
    case TYPES.COMPONENT_SORT_CHANGE:
      return setModule(current, updateComponentSort(current[action.pid], action))
    case TYPES.ADD_MODULE:
      const pid =
        action.pid && current[action.pid] && isContainer(current[action.pid].render)
          ? action.pid
          : 'root'
      current = setModule(current, addChildModule(current[pid], action.id, action.pid))
      return addModule(current, action, pid)
    case TYPES.DELETE_MODULE:
      if (action.id && current[action.id]) {
        if (current[action.id].pid) {
          current = setModule(current, deleteChildModule(current[action.pid], action.id))
        }
      }
      return deleteModule(current, action.id)
    case TYPES.SET_BASE_INFO:
      return update(state, {
        root: {
          config: {
            $merge: action.patch,
          },
        },
      })
    case TYPES.SET_TABLIST_INFO:
      return setModule(current, updateTabConfig(current[action.id], action))
    case TYPES.SET_TAB_ACTIVE_INDEX:
      return setModule(current, updateActiveIndex(current[action.id], action))
    case TYPES.SET_TAB_BASE:
      return setModule(current, updateTabBase(current[action.id], action))
    case TYPES.SET_IMAGE_BOX:
      return setModule(current, updateImageBox(current[action.id], action))
    case TYPES.SET_IMAGE_RES:
      return setModule(current, updateImageRes(current[action.id], action))
    case TYPES.SET_IMAGE_BASE:
      return setModule(current, setImgConfig(current[action.id], action))
    case TYPES.SET_PRODUCTSLIST:
      return setModule(current, setProductsList(current[action.id], action))
    case TYPES.SET_VIDEO_SRC:
      return setModule(current, updateVideoBox(current[action.id], action))
    case TYPES.SET_TEXT_BOX:
      return setModule(current, updateTextBox(current[action.id], action))
    case TYPES.SET_MIXED_BLOCK:
      return setModule(current, updateMixedBlock(current[action.id], action))
    case TYPES.SET_CONFERENCE:
      return setModule(current, updateConference(current[action.id], action))
    case TYPES.ADD_CONFERENCE_TAB:
      return setModule(current, addConferenceTabs(current[action.id]))
    case TYPES.SET_COMMON_CONFIG:
      const { name, value, id } = action
      return setModule(
        current,
        update(current[id], {
          config: {
            [name]: {
              $set: value,
            },
          },
        })
      )
    case TYPES.DELETE_TAB_CHILD_NODE:
      return deleteTabChild(state, action)
    default:
      return state
  }
}
